
import styled from 'styled-components';

export const ContainerButtonsTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;

  /* Adapta para telas menores, como celulares */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const DivSearch = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  /* Adapta para telas menores */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
